import type { ReactNode } from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';

/**
 * Loads Google Maps for everything inside it, with the browser key each app
 * fetches from Directory (`GET maps/config`) — the key no longer sits in a
 * public `config.json`.
 *
 * <p>
 * Renders nothing while the key is still on its way: `APIProvider` loads the
 * script once with the key it mounts with, so mounting early (keyless) and
 * wrapping later would remount the whole screen. With no key configured the
 * children render without maps, and the map widgets show their degraded state
 * instead of failing the app.
 * </p>
 */
export function GoogleMapsProvider({
  apiKey,
  pending,
  children,
}: {
  apiKey: string | null | undefined;
  /** True while the key is being fetched. */
  pending: boolean;
  children: ReactNode;
}) {
  if (pending) return null;
  if (!apiKey) return <>{children}</>;
  return (
    <APIProvider apiKey={apiKey} libraries={['places']}>
      {children}
    </APIProvider>
  );
}
